// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VKSKx","divider":"styles_divider__LUj54"};